import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisRequest = ApiDefinition['/ai/price-title']['POST'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const generatePriceTitle = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/ai/price-title', payload);
  return response.data;
};

export default generatePriceTitle;
